import React, { Component, ReactNode } from 'react';

interface State {
  active: boolean;
}

interface Context {
  state: State;
  toggle: () => void;
}

interface Props {
  children: ReactNode;
}

const { Provider, Consumer } = React.createContext<Context>({} as Context);

class UserMenuProvider extends Component<Props> {
  state = {
    active: false,
  };

  toggle = () => {
    this.setState((prevState: State) => ({
      active: !prevState.active,
    }));
  };

  render() {
    return (
      <Provider
        value={{
          state: this.state,
          toggle: this.toggle,
        }}
      >
        {this.props.children}
      </Provider>
    );
  }
}

export { UserMenuProvider, Consumer as UserMenuConsumer };
